/* global $ */

import React, { Fragment, PureComponent } from 'react';

export default class Carousel extends PureComponent {
  componentDidMount() {
    $('#carousel').on('slide.bs.carousel', event => {
      const $e = $(event.relatedTarget);
      const idx = $e.index();
      const itemsPerSlide = 4;
      const totalItems = $('.carousel-item').length;

      if (idx >= totalItems - (itemsPerSlide - 1)) {
        const it = itemsPerSlide - (totalItems - idx);
        for (let i = 0; i < it; i += 1) {
          // append slides to end
          if (event.direction === 'left') {
            $('.carousel-item')
              .eq(i)
              .appendTo('.carousel-inner');
          } else {
            $('.carousel-item')
              .eq(0)
              .appendTo('.carousel-inner');
          }
        }
      }
    });
  }

  render() {
    return (
      <Fragment>
        <div id="carousel" className="carousel slide" data-ride="carousel">
          <div className="carousel-inner row w-100 mx-0" role="listbox">
            <div className="carousel-item col-md-4 px-0 active">
              <img
                className="img-fluid w-100 d-block"
                src="images/1.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/2.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/c.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/3.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/5.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/a.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/6.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/emmy.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/red-dwarf.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/9.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/10.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/b.png"
                alt=""
              />
            </div>
            <div className="carousel-item col-md-4 px-0">
              <img
                className="img-fluid w-100 d-block"
                src="images/e.png"
                alt=""
              />
            </div>
          </div>
          <a
            className="carousel-control-prev"
            href="#carousel"
            role="button"
            data-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" />
            <span className="sr-only">Previous</span>
          </a>
          <a
            className="carousel-control-next"
            href="#carousel"
            role="button"
            data-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" />
            <span className="sr-only">Next</span>
          </a>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Carousel.jsx